import type { InjectionKey } from 'vue';
import type { Color } from '@arritech/shared/types';
import type { ButtonVariant } from '../Button';
import type { BaseCardProps } from '../Card/Card.model';

export type TabsClassValue = string | Record<string, boolean>;

export type TabIdentifier = string | number | null | undefined;

export type TabPaneItem = {
	id?: TabIdentifier;
	title?: string;
	icon?: string;
	active: boolean;
	_props?: {
		id?: TabIdentifier;
	};
};

export type TabsContext = {
	addTab: (tab: TabPaneItem) => void;
	removeTab: (tab: TabPaneItem) => void;
};

export type TabsRootProps = {
	type?: string;
	activeTab?: string;
	value?: string;
	tabNavWrapperClasses?: TabsClassValue;
	tabNavClasses?: TabsClassValue;
	tabContentClasses?: TabsClassValue;
	vertical?: boolean;
	centered?: boolean;
	activeVariant?: ButtonVariant;
	inactiveVariant?: ButtonVariant;
	color?: Color;
	contentCardType?: BaseCardProps['type'];
};

export type TabsRootEmit = {
	(e: 'tab-click', value: TabIdentifier): void;
	(e: 'input', value: TabIdentifier): void;
};

export type TabPaneProps = {
	title?: string;
	id?: string | null;
	icon?: string;
};

export type TabNavigationItem = {
	id: string | number;
	label: string;
	icon?: string;
	count?: number;
	color?: string;
	disabled?: boolean;
};

export const tabsContextKey: InjectionKey<TabsContext> = Symbol('tabsContext');
